import { GET_REMAINING_LEAVES_USERS } from './redux.actionTypes';

export const getRemainingLeaves = ({ handleSubmit, payload }) => ({
    type: GET_REMAINING_LEAVES_USERS,
    meta: { handleSubmit },
    payload,
});